/* eslint-disable no-console */
const updateMountUI = () => {
  const optionList = document.querySelectorAll('[name="mount"]');
  [].map.call(optionList, (option) => {
    const id = option.getAttribute('aria-controls');
    const expandedContent = document.getElementById(id);
    if (option.checked) {
      expandedContent.classList.remove('hidden');
    } else {
      expandedContent.classList.add('hidden');
    }
  });
};

const getSoffitBracketPrice = (size) => {
  const url = `GetAdapterBracketPrice?size=${size}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const updateSoffitBracketPrice = (state) => {
  const rafterBracketPrice = document.getElementById('rafterBracketPrice');
  const isRafterBracketPrice = rafterBracketPrice !== null;
  if (!isRafterBracketPrice) return;
  const { size } = state;
  getSoffitBracketPrice(size)
    .then((data) => {
      const { success, price } = data;
      if (success) {
        if (rafterBracketPrice && price !== '') {
          rafterBracketPrice.textContent = `of $${price}`;
        }
      }
    });
};

const updateAluminumHoodUI = (state) => {
  const {
    aluminumHoodUpgrade,
    isCostco,
    mount,
  } = state;
  const aluminumHoodDiv = document.getElementById('aluminumHood');
  const isAluminumDiv = aluminumHoodDiv !== null;
  const isAluminumHoodUpgrade = aluminumHoodUpgrade === 'Yes';
  if (mount === 'Wall Bracket' && isCostco && isAluminumDiv && isAluminumHoodUpgrade) {
    aluminumHoodDiv.classList.remove('hidden');
    return;
  }
  if (isAluminumDiv) {
    aluminumHoodDiv.classList.add('hidden');
  }
};

const getAluminumHoodPrice = (modelCode, size) => {
  const url = `GetAluminumHoodPrice?model=${modelCode}&size=${size}`;
  return new Promise((resolve, reject) => {
    fetch(url, {
      method: 'POST',
    })
      .then((response) => {
        if (response.ok) {
          response.json().then(resolve);
        } else {
          response.json().then(reject);
        }
      })
      .catch(console.error);
  });
};

const updateAluminumHoodPrice = (state) => {
  const { modelCode, size } = state;
  const aluminumHoodDiv = document.getElementById('aluminumHood');
  const isAluminumDiv = aluminumHoodDiv !== null;
  if (!isAluminumDiv) return;
  getAluminumHoodPrice(modelCode, size)
    .then((data) => {
      const {
        costcoPrice,
        listPrice,
        success,
      } = data;
      if (success) {
        // Update 3 aluminum hood price fields on page
        const aluminumHoodListPrice = document.getElementById('aluminumHoodListPrice');
        const aluminumHoodCostcoPrice = document.getElementById('aluminumHoodCostcoPrice');
        const aluminumHoodSavingsPrice = document.getElementById('aluminumHoodSavingsPrice');
        aluminumHoodListPrice.textContent = `$${listPrice.toFixed(2)}`;
        aluminumHoodCostcoPrice.textContent = `$${costcoPrice.toFixed(2)}`;
        aluminumHoodSavingsPrice.textContent = `$${(listPrice - costcoPrice).toFixed(2)}`;
      }
    });
};

const resetMountUI = (state) => {
  updateMountUI();
  updateAluminumHoodUI(state);
};

export {
  resetMountUI,
  updateAluminumHoodPrice,
  updateAluminumHoodUI,
  updateSoffitBracketPrice,
  updateMountUI,
};
/* eslint-enable no-console */
